module.exports = __webpack_public_path__ + "static/media/interaction.fde11785.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/interaction.svg
// module id = 273
// module chunks = 0